var _excluded = ["path", "children", "history"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import { profile } from '../../profile';
var getUrl = function getUrl() {
  return profile().aproUrl;
};
export default (function (_ref) {
  var path = _ref.path,
    children = _ref.children,
    history = _ref.history,
    props = _objectWithoutProperties(_ref, _excluded);
  if (history === false) return children;
  return /*#__PURE__*/React.createElement("a", _extends({
    href: history ? '#' : "".concat(getUrl()).concat(path),
    onClick: history ? function (e) {
      e.preventDefault();
      history.push(path);
    } : null
  }, props), children);
});